module.exports = __webpack_public_path__ + "img/me.me0c03b01.svg";